import {
    TextInputStyles,
    TextInputStylesDisabled,
    TextInputStylesError,
    TextInputStylesSuccess,
    TextInputStylesWarning,
} from "shared/components/inputs/input/TextInput.styles";
import BaseButton from "shared/components/inputs/button/BaseButton";
import { FEEDBACK_TYPES } from "shared/config/feedbackTypes";
import { TEXT_VARIANT_STYLES } from "shared/components/data-display/text/Text";
import { TertiaryButtonStyle } from "shared/components/inputs/button/Button.styles";
import styled, { css } from "styled-components";

export const StyledDateFieldWrapper = styled.div`
    position: relative;
    ${TEXT_VARIANT_STYLES.Body_1_1}

    ${TextInputStyles}

     ${(props) =>
        props.isSmallSize
            ? css`
                  ${TextInputStyles} {
                      min-height: 36px;
                      padding: 8px 8px 8px 12px;
                  }
                  ${TEXT_VARIANT_STYLES.Body_2_1};
              `
            : css`
                  ${TextInputStyles} {
                      padding: 12px 8px 12px 12px;
                  }
              `}

    ${(props) =>
        props.feedbackType === FEEDBACK_TYPES.Success &&
        css`
            ${TextInputStylesSuccess}
        `}
     ${(props) =>
        props.feedbackType === FEEDBACK_TYPES.Warning
            ? css`
                  ${TextInputStylesWarning}
              `
            : props.feedbackType === FEEDBACK_TYPES.Error &&
              css`
                  ${TextInputStylesError}
              `}

    ${(props) =>
        props.disabled &&
        css`
            ${TextInputStylesDisabled}
        `}

    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100% !important;
    cursor: default;
`;

export const StyledBaseButtonWrapper = styled.div`
    width: 264px;
    position: absolute;
    left: 0;
    padding-right: 8px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
`;

export const StyledBaseButton = styled(BaseButton)`
    padding: 2px;
    ${TertiaryButtonStyle}
`;

export const DatePickerWrapper = styled.div`
    cursor: not-allowed;
    width: 100%;
`;
